



































import {Component, Vue} from "vue-property-decorator";
import Card from "@/components/Card/Card.vue";
@Component({
  components: {Card}
})
export default class Management extends Vue {
  public name: string = "Management";

  mounted() {

    // removed console_log

  }


}
